/* eslint-disable @typescript-eslint/no-explicit-any */
const castWindow = window as any;

const env = { ...process.env, ...(castWindow.ENV || {}) };

export default env;
